module.exports = __webpack_public_path__ + "img/first_bank_of_nigeria.edf6fde2.svg";